import "./TotalCustomersChart.scss";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import TotalCustomerChartLogic from "./TotalCustomersChartLogic";
import secondaryComponents from "..";
import Images from "../../../assets/images";

const TotalCustomersChart = ({ allCustomerData }) => {
  const { xAxisFormatter } = TotalCustomerChartLogic();

  return (
    <div className="total-customers-chart">
      <div className="total-customers-chart__header">
        <h4 style={{ fontSize: "20px" }} className="font-weight-semibold">
          Total Customers
        </h4>
        <div className="text-right">
          <h4 className="font-weight-semibold">{allCustomerData.count}</h4>
          {/* <span className="d-block" style={{ fontSize: "12px", color: "#19AE57" }}>
                        +14% from last week
                    </span> */}
        </div>
      </div>
      {allCustomerData.trend.length > 0 ? (
        <ResponsiveContainer
          className="total-customers-chart__main"
          width={"100%"}
          aspect={2}
          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
        >
          <BarChart width="auto" height={250} data={allCustomerData.trend}>
            <CartesianGrid
              stroke="#E8E9EB"
              strokeDasharray="5 0"
              horizontal={true}
              vertical={false}
            />
            <XAxis
              tickLine={false}
              tick={{ fontSize: "10px" }}
              axisLine={false}
              tickFormatter={xAxisFormatter}
              dataKey="date"
            />
            <YAxis
              tick={{ fontSize: "10px" }}
              tickLine={false}
              axisLine={false}
            />
            <Tooltip
              wrapperStyle={{ border: "none", outline: "none" }}
              content={<secondaryComponents.CustomerChartTooltip />}
            />
            <Bar dataKey="count" fill="#19AE57" barSize={35} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="mt-5 text-center">
          <img
            width={"150px"}
            src={Images.customersEmptyState}
            alt="No transactions"
          />
          <p className="font-weight-semibold mt-3 dark--text">
            No data available
          </p>
        </div>
      )}
    </div>
  );
};

export default TotalCustomersChart;
